import Loading from "vue-loading-overlay";
import mixin from "../../../mixin";
export default {
    name: "CustomerInfo",
    mixins: [mixin],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            setShippingAddress: 'set-shipping-address',
            cartJsonString: localStorage.getItem('cart'),
            cartPurchaseJsonString: localStorage.getItem('purchase_cart'),
            totalcartData:{},
            myCart: 0,
            hideCart: false,
            hideEmptyCart: true,
            shippingFullName: '',
            shippingPhone: '',
            shippingAddressLineOne: '',
            shippingAddressLineTwo: '',
            shippingCity: '',
            shippingState: '',
            shippingZipCode: '',
            termsAndConditionPageRoute: {name: 'TermsAndCondition'},
        }
    },
    mounted() {
        if(!this.$route.params.backurl)
        {
            console.log("Working...");
        }  
        else
        {
            console.log('Working with Back URL', this.$route.params.backurl);
            this.termsandCOnditionPageRoute={name:'sellDeviceTermsWithBackUrl', params: { backurl: this.$route.params.backurl }};     
            this.setShippingAddress="purchase/set-shipping-address";   
        }  
    },
    created() {
        this.totalcartData = this.loadCartMixin(this.cartJsonString,this.cartPurchaseJsonString); 
        console.log('this.totalcartData = ',this.totalcartData);
    },
    methods: {
        
        checkFieldValidation: function(fieldName) {
            if(typeof(fieldName) != 'undefined')
            {
                if(fieldName == null)
                {
                    return true;
                }
                else if(fieldName.length == 0)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else 
            {
                return true;
            }
        },
        backToSellBox: function() {
            if(!this.$route.params.backurl)
            {
                this.$router.push({name: 'sellCartBox'});    
            }
            else
            {
                this.$router.push({name: 'buyCartBox'});               
            }
        },
        showTermsCondition: function() {             
            if(this.shippingFullName.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your full name.');
                return false;
            }
            if(this.shippingPhone.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your shipping phone.');
                return false;
            }
            if(this.shippingAddressLineOne.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your address 1.');
                return false;
            }
            if(this.shippingCity.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your current city.');
                return false;
            }
            if(this.shippingState.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your current start.');
                return false;
            }
            if(this.shippingZipCode.trim().length == 0)
            {
                this.showMessage('warning', 'Require Field Missing', 'Please enter your current zip code.');
                return false;
            }

            let cart = JSON.parse(this.cartJsonString);
            let cartPurchase = JSON.parse(this.cartPurchaseJsonString);
            console.log(cart);
            let shipping = {};
            shipping.shippingFullName = this.shippingFullName;
            shipping.shippingPhone = this.shippingPhone;
            shipping.shippingAddressLineOne = this.shippingAddressLineOne;
            shipping.shippingAddressLineTwo = this.shippingAddressLineTwo;
            shipping.shippingCity = this.shippingCity;
            shipping.shippingState = this.shippingState;
            shipping.shippingZipCode = this.shippingZipCode;  
            
            if(cart!=null)
            {
                cart.shipping=shipping;
                console.log('Cart = ', cart);
                let sellDeviceCartString=JSON.stringify(cart);
                console.log('Type of object = ',typeof(sellDeviceCartString));
                localStorage.setItem('cart',sellDeviceCartString);
            }

            if(cartPurchase!=null)
            {
                cartPurchase.shipping=shipping;
                console.log('cartPurchase = ', cartPurchase);
                let purchaseDeviceCartString=JSON.stringify(cartPurchase);
                console.log('Type of object = ',typeof(purchaseDeviceCartString));
                localStorage.setItem('purchase_cart',purchaseDeviceCartString);
            }
            
            
            this.$router.push(this.termsAndConditionPageRoute);
            // this.$axios.post(this.$api + 'api/' + this.setShippingAddress, formData).then(response => {
            //     console.log(response.data);
            //     this.$router.push(this.termsAndConditionPageRoute);
            // }).catch(e => {
            //     console.log(e);
            // });
        }
    }
}